"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const staticDataSlice_1 = require("../../../../redux/slices/staticDataSlice");
require("./practiceArea.scss");
const noArea = `Please edit and add practice areas to complete your profile.`;
const noAreaGuest = `Information is not provided.`;
class PracticeArea extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            showModal: false,
            practiceAreas: [],
            updatedAreas: []
        };
        this.changeArea = (items) => {
            const { practiceArea: { temp: { old, changes } } } = this.props;
            let copyChanges = [...changes];
            const copyOld = [...old];
            copyChanges = lodash_1.default.differenceBy(copyChanges, items, 'case_sub_type_id');
            copyChanges = copyChanges.concat(items.map((i) => {
                return Object.assign(Object.assign({}, i), { deleted: true });
            }));
            this.props.changeArea({
                changes: lodash_1.default.uniqBy(copyChanges, 'case_sub_type_id'),
                old: lodash_1.default.differenceBy(copyOld, items, 'case_sub_type_id'),
                changed: true
            }, 'temp', false);
            this.props.setFormUpdate();
        };
    }
    componentDidMount() {
        this.props.getCaseTypes();
    }
    render() {
        const { edit = false, guest = false, practiceArea: { temp: { old, changes } }, staticData: { caseTypes } } = this.props;
        let workingOldCopy = lodash_1.default.cloneDeep(old), items = [], parents = [];
        let all = [...workingOldCopy];
        if ((caseTypes === null || caseTypes === void 0 ? void 0 : caseTypes.length) && ((old === null || old === void 0 ? void 0 : old.length) || (changes === null || changes === void 0 ? void 0 : changes.length))) {
            //if case all sub types checked show case type name
            const grouped = lodash_1.default.groupBy(all, (o) => o.case_type_id);
            for (const g in grouped) {
                const parent = caseTypes.find((ct) => ct.id == g);
                if (parent) {
                    const parentAll = grouped[g].length === parent.subTypes.length;
                    if (parentAll) {
                        all = all.filter(i => i.case_type_id != g);
                        parents.push(parent);
                    }
                }
            }
            all = all.concat(parents);
            items = all === null || all === void 0 ? void 0 : all.map((item) => react_1.default.createElement("div", { className: `selected-p-area ${item.subTypes ? 'parent-area' : ''}`, key: item.id },
                item.name,
                !guest && edit && react_1.default.createElement("span", { onClick: () => this.changeArea(item.subTypes || [item]) })));
        }
        return (react_1.default.createElement("div", null,
            (items === null || items === void 0 ? void 0 : items.length) ? react_1.default.createElement("div", { className: 'selected-item-box' }, items) : '',
            !(items === null || items === void 0 ? void 0 : items.length) && react_1.default.createElement("div", { className: "common-text" }, !guest ? noArea : noAreaGuest)));
    }
}
const mapStateToProps = (state) => {
    const { staticData } = state;
    return {
        staticData
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getCaseTypes: () => dispatch(staticDataSlice_1.getCaseTypes())
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(PracticeArea);
